module.exports = __webpack_public_path__ + "img/4.01e1ff36.jpg";